import React, {useState} from 'react';
import PropTypes from 'prop-types';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import TextField from "@mui/material/TextField";
import LoadingButton from "@mui/lab/LoadingButton";
import LockOpenIcon from '@mui/icons-material/LockOpen';
import axios from 'axios';

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`vertical-tabpanel-${index}`}
      aria-labelledby={`vertical-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `vertical-tab-${index}`,
    'aria-controls': `vertical-tabpanel-${index}`,
  };
}

export default function UnlockFunctionality() {
    const [loading, setLoading] = useState(false)
  const [value, setValue] = useState(0);

  const [vendorId, setVendorId] = useState("")
  const [shippingId, setShippingId] = useState("")

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  async function handleUnlockVendor(event){
    setLoading(true)
    event.preventDefault();
    try{
    const response = await axios.put(`${process.env.REACT_APP_API_URL}/api/v1/vendor/${vendorId}/unlock`, null, {
      headers: {
        Authorization: `Bearer ${JSON.parse(
          localStorage.getItem("accessToken")
        )}`,
      },
    })
    console.log(response.data);
    setLoading(false)
    setVendorId("")
    }catch(err){
      setLoading(false)
      console.log(err)
    }
  }

  async function handleUnlockShipment(event){
    setLoading(true)
    event.preventDefault();
    try{
    const response = await axios.put(`${process.env.REACT_APP_API_URL}/api/v1/shipment/${shippingId}`, null, {
      headers: {
        Authorization: `Bearer ${JSON.parse(
          localStorage.getItem("accessToken")
        )}`,
      },
    })
    console.log(response.data);
    setLoading(false)
    setShippingId("")
    }catch(err){
      setLoading(false)
      console.log(err)
    }
  }
  return (
    <Box
      sx={{ flexGrow: 1, bgcolor: 'transpirant', display: 'flex', height: 224, alignItems: 'center' }}
    >
      <Tabs
        orientation="vertical"
        variant="scrollable"
        value={value}
        onChange={handleChange}
        aria-label="Vertical tabs example"
        sx={{ borderRight: 1, borderColor: 'divider' }}
      >
        <Tab label="Unlock Vendor" {...a11yProps(0)} />
        <Tab label="Unlock Shipment" {...a11yProps(1)} />
      </Tabs>
      <TabPanel value={value} index={0}>
      <Box
            component="form"
            onSubmit={handleUnlockVendor}
            method="POST"
            sx={{ mt: 1 }}>
            <TextField
              margin="normal"
              required
              fullWidth
              id="vendor-id"
              label="Vendor Id"
              name="vendor-id"
              value={vendorId}
              onChange={(e) => setVendorId(e.target.value)}
            />
            <LoadingButton
              type="submit"
              fullWidth
              loading={loading}
              startIcon={<LockOpenIcon />}
              loadingPosition="end"
              variant="contained"
              sx={{ mt: 3, mb: 2, bgcolor: "secondary.main" }}>
              Unlock Vendor
            </LoadingButton>
          </Box>
      </TabPanel>
      <TabPanel value={value} index={1}>
      <Box
            component="form"
            onSubmit={handleUnlockShipment}
            method="POST"
            sx={{ mt: 1 }}>
            <TextField
              margin="normal"
              required
              fullWidth
              id="shipment-id"
              label="Shipment Id"
              name="shipment-id"
              value={shippingId}
              onChange={(e) => setShippingId(e.target.value)}
            />
            <LoadingButton
              type="submit"
              fullWidth
              loading={loading}
              startIcon={<LockOpenIcon />}
              loadingPosition="end"
              variant="contained"
              sx={{ mt: 3, mb: 2, bgcolor: "secondary.main" }}>
              Unlock Shipment
            </LoadingButton>
          </Box>
      </TabPanel>
    </Box>
  );
}